<template>
  <div class="flex flex-col w-2/12 py-2 border-r-2">
    <!--  Add chat           -->
    <div class="flex justify-end p-3 border-b-2">
      <Tooltip>
        <template #content>
          Add new chat
        </template>
        <template #parent>
          <div class="flex cursor-pointer" @click="addNewChat()">
            <WcIconSolidPlus height="18" width="18" color="#040410"  opacity="=0.6" />
          </div>
        </template>
      </Tooltip>
    </div>
    <div class="flex h-full justify-between flex-col my-2">
     <div v-if="loading" class="flex flex-col items-center">
       <LinesShimmer :lines="10" background-color="#fff" :show-avatar="false"/>
     </div>
      <div v-if="!loading" class="flex flex-col space-y-1 mx-4 2xl:max-h-96 xl:max-h-52 lg:max-h-40 md:max-h-40 sm:max-h-30 overflow-y-auto cursor-pointer">
        <div class="select-thread mx-2" @click="fetchThread(thread.id)" :key="'thread'+thread.id+'ind'+inx" v-for="(thread, inx) in  chatThreads" :style="`${thread.id === currentThreadId ? 'background: #F8F8F9;border-right: 2px solid rgba(4, 4, 16, 0.6;' : ''}`">
          <WcTypography :key="thread.id+'threadName'" class="thread" size="xs" :title="thread.name" weight="500" />
        </div>
      </div>
      <div class="flex flex-col space-y-2">
        <!-- Help Centre Button -->
        <div @click="openHelpcenter" class="support-link justify-between xl:mx-4 lg:mx-2 md:mx-2 sm:mx-1">
          <div class="flex"><WcTypography size="xs" title="Help centre" weight="500" /></div>

          <div class="flex">
            <WcIconExternalLink size="md" color="rgba(4, 4, 16, 0.6)" />
          </div>
        </div>

        <!-- WhatsApp Support Button -->
        <div @click="openWhatsHelp" class="support-link justify-between xl:mx-4 lg:mx-2 md:mx-2 sm:mx-1">
          <div class="flex"><WcTypography size="xs" title="WhatsApp support" weight="500" /></div>
          <div class="flex">
            <WcIconWhatsApp  />
          </div>
        </div>

        <!-- Share Product Feedback Button -->
        <div @click="openFeedbackForm" class="support-link justify-between xl:mx-4 lg:mx-2 md:mx-2 sm:mx-1">
          <div class="flex"><WcTypography size="xs" title="Share product feedback" weight="500" /></div>
          <div class="flex">
            <WcIconFeedback color="rgba(4, 4, 16, 0.6)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import WcIconExternalLink from '@/components/UILibrary/Icons/WcIconExternalLink.vue'
import WcIconWhatsApp from '@/components/UILibrary/Icons/WcIconWhatsApp.vue'
import WcIconFeedback from '@/components/UILibrary/Icons/WcIconFeedback.vue'
import { UserModule } from '@/store/modules/user'
import LoadingAnimation from '@/components/UILibrary/loading-animation.vue'
import LinesShimmer from '@/components/UILibrary/Shimmers/LinesShimmer.vue'
import WcIconPlusUnfilled from '@/components/UILibrary/Icons/WcIconPlusUnfilled.vue'
import Tooltip from '@/components/UILibrary/tooltip.vue'
import WcIconSolidPlus from '@/components/UILibrary/Icons/WcIconSolidPlus.vue'

@Component({
  name: 'NewChatSection',
  components: { WcIconSolidPlus, Tooltip, WcIconPlusUnfilled, LinesShimmer, LoadingAnimation, WcIconFeedback, WcIconWhatsApp, WcIconExternalLink, WcTypography }
})
export default class extends Vue {
  @Prop({ required: true, type: Function }) addNewChat!: Function;
  @Prop({ required: true, type: Function }) fetchThread!: Function;
  @Prop({ required: true }) chatThreads!: {name: string, id: string}[]
  @Prop({ required: true }) currentThreadId!: string
  @Prop({ required: true }) loading!: boolean

  openHelpcenter() {
    window.open('https://whitecarrot.notion.site/Whitecarrot-io-Help-Centre-9add74c9165a4a2aa6dec8d57cb64f1b', '_blank')
  }

  openWhatsHelp() {
    // https://api.whatsapp.com/send/?phone=%2B971581746200&text&type=phone_number&app_absent=0
    // https://wa.me/+971581746200
    window.open('https://api.whatsapp.com/send/?phone=%2B971581746200&text&type=phone_number&app_absent=0', '_blank')
  }

  openFeedbackForm() {
    window.open(`https://docs.google.com/forms/d/e/1FAIpQLSev5sWdX2B2bIkBfgq8uQXYkDVKDSmuV-KjtnQ2AOzQLYoFAw/viewform?usp=pp_url&entry.605810767=${UserModule.companyName}&entry.1718894749=${UserModule.email}&entry.356970377=${UserModule.firstName}`, '_blank')
  }
}
</script>
<style scoped>
.support-link{
  /* Text field */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  gap: 10px;
  background: #F8F8F9;
  border: 1px solid #E9E9EC;
  border-radius: 10px;
  cursor: pointer;

}

.select-thread{
  /* Frame 35495 */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 8px;
  border-radius: 5px 0px 0px 5px;
}

.thread {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.thread:hover {
  white-space: normal;
}

</style>
